<template>
  <div class="dialog-login text-checked">
    <div class="dialog-login-title text-center">
      <h1>考不倒提升成绩更快</h1>
    </div>
    <div class="sign-type clear-fix" v-if="!isLogin">
      <span class="w_50 text-center inline-block pull-left pointer relative" v-for="(item,index) in signList" @click="signType(index)" :class="signSpan == index? 'sign-avtive' : ''">{{item}}</span>
    </div>
    <el-form :rules="rules" ref="form":model="form" v-if="formRestart" :class="isLogin?'login-top':'margin-top'" class="login-input">
      <el-form-item prop="phone">
        <i class="el-icon-mobile-phone" />
        <el-input v-model="form.phone" placeholder="输入手机号" type="number" maxlength="11"></el-input>
      </el-form-item>
      <el-form-item prop="code">
        <i class="el-icon-lock" />
        <el-input v-model="form.code" :placeholder="signDesc[signSpan]" :maxlength="signSpan? 20 : 6" :type="signSpan? 'password':'number'" @keyup.enter.native="signSubmit">
          <template slot="append" class="pointer" v-if="!signSpan" :phone="form.phone">
            <div @click="sendCode" v-if="!againSend" class="codeText">获取验证码</div>
            <div v-else>{{'重新发送 ' + curCount }}</div>
          </template>
        </el-input>
      </el-form-item>

      <div class="text-right" v-if="!isLogin"><span class="pointer" @click="forget()">忘记密码</span></div>
    </el-form>

    <div class="login-btn w_90 marginCenter" :class="isLogin?'login-top':''">
      <el-button type="primary" class="w_100" color="#FFF" @click="signSubmit" :loading="submit">{{isLogin?'注 册' : '登 录'}}</el-button>
    </div>
    <div class="login-agreement" v-if="isLogin">
      <p class="text-center">注册即代表你同意<em>《用户协议》</em>和<em>《隐私协议》</em></p>
    </div>
    <div slot="footer" class="dialog-footer">
      <p class="text-center">{{isLogin? '已有账号' : '没有账号'}}? <em class="c00a0e9 pointer" @click="loginType">{{isLogin ? '登录' : '注册'}}</em></p>
    </div>
    <gtDemo v-show="false" ref="verify" @success="sendSuccess"/>

  </div>
</template>

<script>
  import { login,sendSms,code_login } from "@/api/login";
  import Utils from '@/utils/util'
  import gtDemo from "./gt"
  export default {
    name: "login.vue",
    components:{ gtDemo },
    props:{
      islogin:{
        type: Boolean,
        default:_=>{
          return false
        }
      },
    },
    data(){
      // 手机号验证
      let checkPhone = (rule, value, callback) => {
        const phoneReg = /^1[3456789]\d{9}$/
        if (!value) {
          return callback(new Error('请输入手机号'))
        }
        setTimeout(() => {
          if (phoneReg.test(value)) {
            callback()
          } else {
            callback(new Error('请输入正确手机号'))
          }
        }, 100)
      };
      return{
        submit: false,
        isLogin:this.islogin,
        form:{
          phone: '',
          code: '',
        },
        formRestart: true,
        rules: {
          phone: [
            {required: true, validator: checkPhone, trigger: 'blur'},
          ],
          code: [
            {required: true, message: '请输入验证码', trigger: 'change'}
          ],
        },
        signList: ['手机验证码登录','账号密码登录'],
        signSpan: 0, // 0 验证码登录 1 账号密码登录
        signDesc: {
          0:'请输入验证码',
          1:'请输入密码'
        },
        againSend: false,
        curCount: ''
      }
    },
    mounted() {

    },
    methods:{
      forget(){
        // this.$message.error('暂未开通，敬请期待');
        this.$emit('forget',this.form.phone);
      },
      loginState(res){
        this.submit = true;
        this.$message({
          message: '登录成功',
          type: 'success',
          offset: 100,
        });
        this.$emit('login',res);
      },
      // 验证成功以后发送验证码
      sendSuccess(res){
        sendSms({
          geetest_challenge: res.geetest_challenge,
          geetest_validate: res.geetest_validate,
          geetest_seccode: res.geetest_seccode,
          mobile: this.form.phone
        }).then(()=>{
          this.curCount = 120;
          this.againSend = true;
          this.InterValObj = window.setInterval(this.SetRemainTimes, 1000);
        })
      },
      // 验证码发送成功以后倒计时重复发送
      SetRemainTimes (){
        if(this.curCount == 0) {
          window.clearInterval(this.InterValObj);
          this.againSend = false;
        } else {
          this.curCount --;
        }
      },
      // 发送验证码之前的验证
      sendCode(){
        this.$refs['form'].validateField('phone', valid => {
          if (!valid) {
            this.$refs.verify.gt();
          } else {
            return false;
          }
        });
      },
      // 登录/注册
      signSubmit(){
        this.$refs['form'].validate((valid) => {
          if (valid) {
            // 验证码登录 & 注册
            if(!this.isLogin && !this.signSpan || this.isLogin){
              code_login({
                mobile: this.form.phone ,
                code : this.form.code,
                // client: 'web',
              }).then(res=>{
                this.setLogin(res);
                this.loginState(res);
              })
            }
            // 账号密码登录
            if(!this.isLogin && this.signSpan){
              login({
                mobile:this.form.phone,
                pwd: this.form.code,
                // client: 'web',
              }).then(res=>{
                this.setLogin(res);
                this.loginState(res);
              })
            }
          } else {
            return false;
          }
        });
      },
      setLogin(res){
        const auth = this.$auth;
        auth.setToken(res.token);
        this.$member();
        Utils.$emit('sucess')
        setTimeout(_=>{
          // this.$$.routerPush('user')
        },1000)
        // auth.setUserInfo(res.member_info);
      },
      clearCode(){
        this.formRestart = false;
        this.$nextTick(_=>{
          this.form.code = '';
          this.formRestart = true;
        })
      },
      signType(index){
        this.signSpan = index;
        this.clearCode();
      },
      loginType(){
        this.isLogin = !this.isLogin;
        this.clearCode();
      },
    }
  }
</script>

<style scoped>
  .text-right{
    margin: 0.3rem 0.25rem;
  }
  .text-right span:hover{
    color: #00a0e9;
  }
  .el-form-item{
    margin: 0;
  }
  .el-form-item + .el-form-item {
    margin-top: 22px;
  }
  >>>.login-top{
    margin-top: 0.8rem;
  }
  >>>.margin-top{
    margin-top: 0.5rem;
  }
  .login-btn{
    margin-bottom: 0.5rem;
  }
  .login-btn .el-button{
    border-radius: 0.15rem;
    overflow: hidden;
    font-size: 0.25rem;
  }
  .login-agreement em:hover{
    color: #7e909d;
  }
  .login-agreement em{
    color: #5b656d;
    cursor: pointer;
  }
  .login-agreement{
    font-size: 0.2rem;
    padding-top: 0.25rem;
    padding-bottom: 0.5rem;
    color: #a8aaad;
  }
  .sign-type span{
    line-height: 0.6rem;
    font-size: 0.25rem;
    display: inline-block;
  }
  .sign-type{
    margin-top: 0.15rem;
  }
  .sign-avtive{
    font-weight: bold;
    color: #333;
  }
  .sign-avtive:after{
    content: '';
    width: 10%;
    height: 2px;
    background: #00a0e9;
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -5%;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/modal/login.vue